import type { PageVisibleState } from '../../metric/base-metric';
import type {
	BaseMetricDataWithStartAndStop,
	BasePageLoadMetricDataWithStartAndStop,
	PerformanceEventConfig,
} from '../../types';

export const pageVisibleState = (
	_config: PerformanceEventConfig,
	data: BaseMetricDataWithStartAndStop | BasePageLoadMetricDataWithStartAndStop,
): {
	'pageVisible:state': PageVisibleState;
} => {
	return {
		'pageVisible:state': data.pageVisibleState,
	};
};
